<template>
  <div class="video-player">
    <el-container>
      <!-- Header with Save Progress -->
      <el-header class="header">
        <!-- 退出按钮放在左上角 -->
        <div class="header-left">
          <el-button type="success" size="small" @click="exitpage">
            退出视频学习
          </el-button>
        </div>
        <div class="header-right">

          <el-button type="success" size="small" @click="saveProgress">
            保存进度
          </el-button>
        </div>
      </el-header>


      <el-main>
        <el-card shadow="hover" class="video-container custom-card-size" v-if="videoList.length > 0">
          <div v-if="currentVideoPlayed" class="task-completed-tag">
            <el-tag type="success" effect="dark">
              任务已完成
            </el-tag>
          </div>
          <video
              ref="videoPlayer"
              :src="currentVideo.url"
              controls
              autoplay
              class="video-player-element"
              @ended="handleVideoEnded"
              :currentTime="getCurrentTime"

          ></video>

<!--          @play="checkVideoStatus"-->
          <p class="video-title">{{ currentVideo.title }}</p>
        </el-card>

        <!-- Video Controls -->
        <div class="controls" v-if="videoList.length > 0">
          <el-button
              type="primary"
              @click="playPreviousVideo"
              :disabled="isFirstVideo"
          >
            上一个视频
          </el-button>
          <el-button
              type="primary"
              @click="playNextVideo"
              :disabled="isLastVideo"
          >
            下一个视频
          </el-button>
        </div>

        <!-- No videos found message -->
        <div v-else>
          <p>没有找到视频，请检查视频列表。</p>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import axios from '@/axios'
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      totalStayDuration: 0, // 页面总停留时长（秒）
      stayStartTime: null,  // 页面停留开始时间
      stayTimer: null,      // 定时器，定时计算页面停留时长
      videoList: [],        // 存储视频列表
      planId: '',           // 存储计划 ID
      userid: '',           // 当前用户 ID
      organizationID: '',   // 当前组织 ID
      currentVideoIndex: 0, // 当前视频索引
      currentVideoPlayed: false, // 当前视频是否播放完毕
      videoProgress: [],    // 存储每个视频的播放进度
    };
  },

  mounted() {
    this.startStayTimer(); // 页面加载时启动停留计时
    window.addEventListener("beforeunload", this.showExitDuration); // 页面关闭时显示总停留时长

    // 读取 URL 参数
    this.planId = this.$route.query.planId;
    this.userid = this.$route.query.userid;
    this.organizationID = this.$route.query.organizationID;

    console.log("当前计划 ID:", this.planId);
    console.log("当前用户 ID:", this.userid);

    // 加载视频进度
    this.loadProgress();

    // 获取视频列表
    axios.get('/XY/plan/videos', { params: { planid: this.planId } })
        .then(response => {
          if (response.data && response.data.data && response.data.data.length > 0) {
            // 确保返回的数据格式正确并且非空
            this.videoList = response.data.data.map(video => ({
              id: video.id,
              title: video.videoName,  // 设置视频标题
              url: video.videoPath,    // 设置视频路径
            }));
            console.log('视频列表加载成功:', this.videoList);
          } else {
            this.videoList = [];
            // console.log('未找到视频');

            ElMessage.error('未找到视频');
          }
        })
        .catch(error => {
          this.videoList = [];

          ElMessage.error('获取视频列表失败');
        });

    // this.   checkVideoStatus()


  },

  computed: {
    // 获取当前视频信息
    currentVideo() {
      return this.videoList.length > 0 ? this.videoList[this.currentVideoIndex] : {};
    },
    // 判断是否是第一个视频
    isFirstVideo() {
      return this.currentVideoIndex <= 0;
    },
    // 判断是否是最后一个视频
    isLastVideo() {
      return this.currentVideoIndex >= this.videoList.length - 1;
    },
    // 获取当前视频的播放进度
    getCurrentTime() {
      console.log(this.currentVideo)
      console.log(this.videoProgress)
      const progress = this.videoProgress.find(item => item.id === this.currentVideo.id);
      console.log('获取当前视频的播放进度    '+progress)
      return progress ? progress.time : 0; // 如果有保存的进度，返回保存的时间
    },
  },

  methods: {
    exitpage() {
      clearInterval(this.stayTimer); // 清理定时器
      window.removeEventListener("beforeunload", this.showExitDuration); // 移除事件监听
      this.saveProgress();
      alert('您学习了' + this.totalStayDuration + '秒');
      this.$router.push({ path: '/z', query: { userid: this.userid, organizationID: this.organizationID } });
    },

    // 启动页面停留计时
    startStayTimer() {
      this.stayStartTime = Date.now(); // 记录页面开始时间
      this.stayTimer = setInterval(this.updateStayDuration, 1000); // 每秒更新一次停留时长
    },

    // 更新页面停留时长
    updateStayDuration() {
      const currentDuration = Math.floor((Date.now() - this.stayStartTime) / 1000);
      this.totalStayDuration = currentDuration;
    },

    // 在页面关闭时显示总停留时长
    showExitDuration() {
      console.log('总停留时长: ' + this.totalStayDuration + '秒');
    },

    // 加载视频进度
    loadProgress() {


axios.get(`XY/plan/video/progress/${this.userid}/${this.planId}`).then(response => {
  if ( response.data.success&& response.data.data.length>0) {
    this.videoProgress = response.data.data;
    console.log('dawd awd ad'+this.videoProgress)
    if(this.videoProgress[0].status)
    {
      this.$message.success("视频已经播放完毕可自由学习");
      this.currentVideoPlayed = true;
    }
  }
  else {
    this.$message.error("获取进度失败");
  }
}).catch(error => {
  this.$message.error("获取进度失败");
})

      // this.   checkVideoStatus()


    },

    // 保存视频播放进度
    async saveProgress() {
      // 更新当前视频播放时间
      this.handleTimeUpdate(this.$refs.videoPlayer.currentTime);

      // 创建视频观看历史数组
      const his = this.videoProgress.map(item => ({
        contentId: item.id,
        watchDuration: item.time,
        userId: this.userid,
        planId: this.planId,
        status:item.status
      }));



      try {
        // 发送保存进度的请求
        const response = await axios.post('XY/plan/video/progress', his, {
          params: {
            totaaltime: this.totalStayDuration // 传递总时间
          }
        });


        // 根据响应判断是否保存成功
        if (response.data.success) {
          this.$message.success("保存进度成功");
        } else {
          this.$message.error("保存进度失败");
        }
      } catch (error) {
        // 处理请求错误
        console.error("保存进度时出错:", error);
        this.$message.error("保存进度失败，请稍后再试");
      }
    }
,

    // 处理视频播放结束事件
    handleVideoEnded() {


      var find = this.videoProgress.findIndex(item => item.id === this.currentVideo.id);
      if(find===-1)
      {
console.log('没有记录的视频')
        this.handleTimeUpdate(this.$refs.videoPlayer.currentTime)
        find=this.videoProgress.length-1
      }


this.videoProgress[find].status = 1
      console.log(this.videoProgress[find].status)

      this.currentVideoPlayed = true;
      // this.saveProgress();

      this.checkVideoStatus()
    },

    // 处理视频播放进度更新
    handleTimeUpdate(currentTime) {


      console.log('更新进度'+currentTime)
      var find = this.videoProgress.findIndex(item => item.id === this.currentVideo.id);

      console.log(find)
      if(find===-1)
      this.videoProgress.push({ id: this.currentVideo.id, time: currentTime,status:0 });
      else
      this.videoProgress[find].time = currentTime

   console.log( this.videoProgress)
    },

    // 跳转到上一个视频
    playPreviousVideo() {
      if (!this.isFirstVideo) {

      this.  handleTimeUpdate(this.$refs.videoPlayer.currentTime)


        this.currentVideoIndex--;
        // this.currentVideoPlayed = false;
        this.   checkVideoStatus()
      }
    },

    // 跳转到下一个视频
    playNextVideo() {
      if (!this.isLastVideo) {

        this.  handleTimeUpdate(this.$refs.videoPlayer.currentTime)
        this.currentVideoIndex++;
        // this.currentVideoPlayed = false;

        this.   checkVideoStatus()
      }

    },

    // 检查视频播放状态
    checkVideoStatus() {

      var find = this.videoProgress.find(item => item.id === this.currentVideo.id);
if(find.status)
{

  this.$message.success("视频已经播放完毕可自由学习");
  this.currentVideoPlayed = true;
}

else this.currentVideoPlayed = false
    }
  }
};
</script>
<style scoped>
.video-player {
  padding: 20px;
}

.video-container {
  position: relative;
}

.video-player-element {
  width: 100%;
  height: auto;
}

.controls {
  margin-top: 20px;
  text-align: center;
}

.header {
  padding: 10px;
}

.header-right {
  display: flex;
  justify-content: flex-end;
}

.task-completed-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1; /* 确保它在视频卡片之上 */
}

.video-title {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
}

.custom-card-size {
  width: 80%;  /* 设置宽度为父容器的 80% */
  max-width: 800px;  /* 设置最大宽度为 800px */
  height: auto;
  margin: 0 auto;  /* 居中对齐 */
}

/* 左上角退出按钮样式 */
.header .header-left {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}

.header .header-right {
  display: flex;
  justify-content: flex-end;
}
</style>

